import type { OdysseyModelAnimation } from "@/odyssey/OdysseyModelAnimation";
import type { OdysseyModelAnimationManager } from "@/odyssey/OdysseyModelAnimationManager";
import * as THREE from "three";
import { IOdysseyControllerFrameGeneric } from "@/interface/odyssey/controller/IOdysseyControllerFrameGeneric";
import { IOdysseyControllerGeneric } from "@/interface/odyssey/controller/IOdysseyControllerGeneric";
import { OdysseyModelControllerType } from "@/enums/odyssey/OdysseyModelControllerType";

/**
 * OdysseyController class.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file OdysseyController.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 */
export class OdysseyController {

  type: OdysseyModelControllerType = OdysseyModelControllerType.INVALID;
  supermodelLink: number = -1;
  uuid: string = crypto.randomUUID();

  vec3;
  quaternion;
  frameCount: number;
  data: IOdysseyControllerFrameGeneric[] = [];

  constructor( controller: IOdysseyControllerGeneric ){
    Object.assign(this, controller);
    this.supermodelLink = controller.supermodelLink;
    this.vec3 = new THREE.Vector3(0, 0, 0);
    this.quaternion = new THREE.Quaternion(0, 0, 0, 1);
  }

  /** Interpolate single-float keyframes (`value` only). */
  static lerp1(last: IOdysseyControllerFrameGeneric, next: IOdysseyControllerFrameGeneric, fl: number): number {
    return (next.value - last.value) * fl + last.value;
  }

  setFrame(manager: OdysseyModelAnimationManager, anim: OdysseyModelAnimation, data: IOdysseyControllerFrameGeneric){
    
  }

  animate(manager: OdysseyModelAnimationManager, anim: OdysseyModelAnimation, last: IOdysseyControllerFrameGeneric, next: IOdysseyControllerFrameGeneric, fl: number = 0){
    
  }

  update(){

  }

}
